<template>
	<div>
		<el-row class="" type="flex" :gutter="20">
			<el-col :span="24">
				<div class="filter-inline-panel cle">
					<div class="filter-panel fl">
					</div>
					<div class="list-opinion fr">
						<el-button type="primary" size="mini" @click="$router.back(-1)">返回</el-button>
						<el-button type="primary" size="mini" v-if="hasBtn('btn_add')" @click="emailEdit()">新建</el-button>
					</div>
				</div>
				<el-table :data="list" border row-key="id" size="mini" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column prop="name" align="center"  label="名称"></el-table-column>
					<el-table-column prop="code" align="center"  label="值编码"></el-table-column>
					<el-table-column prop="status" align="center"  label="是否显示">
						<template slot-scope="scope">
							{{scope.row.status==1?'显示':'隐藏'}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="220" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="emailEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" @click="emailDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<!-- <el-row class="tree-content w100" type="flex" :gutter="20">
			<el-col :span="24">
				<div class="p1"><br>值编码为-1的不要，修改前台判断-1的显示文本框自定义内容。</div>
			</el-col>
		</el-row> -->
		<el-dialog title="编辑" width="700px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
		  <el-form :model="editForm" size="mini"  :inline="true" label-width="100px"  :rules="editFormRules" ref="editForm">
			<el-form-item label="名称" prop="name">
			  <el-input v-model="editForm.name" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="值编码" prop="code">
			  <el-input v-model="editForm.code" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="排序" prop="sort">
			  <el-input v-model="editForm.sort" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="是否显示" prop="status">
				<el-select v-model="editForm.status" placeholder="请选择状态" class="w100">
					<el-option label="是" value="1"></el-option>
					<el-option label="否" value="0"></el-option>
				</el-select>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
			<el-button size="mini"  @click.native="editFormVisible = false">取消</el-button>
			<el-button size="mini"  type="primary" @click.native="editSubmit('editForm')">提交</el-button>
		  </div>
		</el-dialog>
	</div>
</template>














<script>
export default {
  data () {
		return {
			id:'',
			editFormVisible:false,
			editForm:{
				name:'',
				code:'',
				sort:'',
				status:1,
			},
			list:[],
			editFormRules: {
				code: [{
					required: true,
					message: '请输入值编码',
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: '请输入名称',
					trigger: 'blur'
				}],
			},
		}
  },
  // 初始事件
	mounted: function () {
		this.id=this.$route.query.id;
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "dictionaryListList";
			var datas = {
				dictionary_id:this_.id,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res;
			})
		},
		// 编辑
		emailEdit(e){
			if (e) {
				this.editForm=e;
			}else{
				this.editForm={
					name:'',
					code:'',
					sort:'',
					status:'1',
				}
			}
			this.editFormVisible=true;
		},
		// 保存
		editSubmit(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "addDictionaryList";
					var datas={
						dictionary_id:this_.id,
						name:this_.editForm.name,
						code:this_.editForm.code,
						sort:this_.editForm.sort,
						status:this_.editForm.status,
					}
					var tishi='添加成功';
					if(this_.editForm.id){
						datas['id']=this_.editForm.id;
						url = "editDictionaryList";
						tishi='修改成功';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				}else{
					return false;
				}
			})
		},
		// 删除
		emailDelete(e) {
			console.log(e)
			var this_ = this;
			var url = "deleteDictionaryList";
			var datas = {
				id:e.id
			};
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {
			});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages=this.pages;
			pages['perpage']=val;
			this.pages=pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages=this.pages;
			pages['page']=val;
			this.pages=pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>

<style scoped>
.filter-inline-panel{
	margin-bottom: 22px;
}
.page-pagination{
	padding: 20px 10px;
}
.p1{
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/views/data/parameter_info.vue